import { PayoutConfig } from "./payoutConfig";

export class ProgressionSource {
    id: number;
    progressionId: number;

    payoutConfig: PayoutConfig;
    payoutConfigId: number;
    
    leadersToSkip: number;
    minToProgress: number;
    maxToProgress: number;
    priorityOrder: number;

    constructor() {
        this.leadersToSkip = 0;
        this.minToProgress = 0;
        this.maxToProgress = 1;
        this.priorityOrder = 1;
    }
}


// WEBPACK FOOTER //
// ./src/model/progression-source.ts